import { DataType, IValidationError } from 'flux-definition';
import { AbstractDataItem } from './data-item-abstract';

/**
 * Data item class for the STRING_HTML data type. Data items in shape models with the STRING_HTML
 * data type will be deserialized into instances of this class by the `DataItemFactory`.
 */
export class StringHtmlDataItem extends AbstractDataItem<DataType.STRING_HTML> {
    /**
     * Checks whether the given value is valid (returns the error if any)
     */
    public validate( value: typeof StringHtmlDataItem.prototype.value ): IValidationError {
        if ( value === undefined ) {
            return null;
        }
        if ( typeof value === 'string' ) {
            // TODO: sanitize the html
            return null;
        }
        return { message: `"${value}" is not a valid string` };
    }
}
